import { useFlags } from 'launchdarkly-react-client-sdk';

/**
 * Delayed payout setup feature flag (LaunchDarkly key: `delayed-payout-setup`).
 *
 * Gates the whole self-serve payout unit as one kill-switch:
 *  - OFF: today's behavior (billing gated on `paymentsEnabled`, "Chat with us"
 *    modal, payout prompt keyed off `paymentsEnabled`).
 *  - ON: providers bill without pre-approval; connecting a payout account requires
 *    the provider to be verified by support. Verification can be requested from
 *    Finances settings at any time (no invoice needed); the billing-page nudge
 *    waits for the first Stripe-paid invoice.
 *
 * Gate-lift and verified payout ship together because lifting the gate is only
 * safe while payout still requires verification.
 */
export function useDelayedPayoutSetup(): boolean {
  return Boolean(useFlags().delayedPayoutSetup);
}
